import React, { useEffect, useState } from "react";
import classes from "./Layout.module.css";
import Lottie from "lottie-react";
import snowfallAnimation from "../animations/snowfall-animation.json";

const Layout = ({ children }) => {
    return (
        <div className={classes.game_overlay}>
            <div className={classes.game_container}>
                <div className={classes.animations}>
                    <Lottie
                        animationData={snowfallAnimation}
                        loop
                        autoPlay
                        className={classes.animation}
                    />
                </div>
                <div className={classes.game}>
                    {children}
                </div>
            </div>
        </div>
    )
};
export default Layout;